var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7259 4.10298C14.848 1.96567 18.2887 1.96567 20.4107 4.10298C22.5329 6.24029 22.5329 9.70555 20.4107 11.8429L17.587 14.6869C15.4682 16.8208 12.0331 16.8208 9.91432 14.6869C9.52648 14.2963 9.52648 13.6659 9.91432 13.2753L9.94016 13.2492C10.3264 12.8603 10.9555 12.8603 11.3417 13.2492C12.6721 14.5892 14.8291 14.5892 16.1596 13.2492L18.9833 10.4052C20.3171 9.0619 20.3171 6.88394 18.9833 5.54061C17.6496 4.19728 15.4871 4.19728 14.1533 5.54061L13.1395 6.56173C12.7433 6.96072 12.098 6.96072 11.7019 6.56173C11.3097 6.16675 11.3097 5.52934 11.7019 5.13437L12.7259 4.10298ZM11.3519 20.8721C9.22388 23.0314 5.7607 23.0443 3.61665 20.9009C1.47259 18.7576 1.45957 15.2696 3.58756 13.1103L6.34275 10.3145C8.45351 8.17271 11.8886 8.1599 14.0153 10.2859L14.0821 10.3526C14.4757 10.7461 14.4781 11.3835 14.0874 11.78C13.6927 12.1804 13.0474 12.1828 12.6498 11.7853L12.5933 11.7288C11.2579 10.3939 9.1009 10.4019 7.77551 11.7468L5.02032 14.5425C3.67769 15.9049 3.6859 18.1056 5.03867 19.458C6.39144 20.8103 8.57649 20.8021 9.91912 19.4398L10.8972 18.4473C11.2919 18.0468 11.9372 18.0444 12.3348 18.4419C12.7284 18.8354 12.7308 19.4728 12.3401 19.8693L11.3519 20.8721Z",
    fill: "#000408"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);
export default __webpack_public_path__ + "static/media/copy-link.0670327ca34fafdcd0065a6d95224861.svg";
export { ForwardRef as ReactComponent };